"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromLong_1 = require("./FromLong");
var NetworkAddress_1 = require("./NetworkAddress");
var ToLong_1 = require("./ToLong");
var NumberHosts_1 = require("./NumberHosts");
function broadcastAddress(subnet) {
    var hostLong = ToLong_1.toLong(NetworkAddress_1.networkAddress(subnet));
    var broadcastLong = hostLong + (NumberHosts_1.numberHosts(subnet, true) - 1); /* -1  as one Address already accounted for*/
    return FromLong_1.fromLong(broadcastLong);
}
exports.broadcastAddress = broadcastAddress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnJvYWRjYXN0QWRkcmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJyb2FkY2FzdEFkZHJlc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx1Q0FBcUM7QUFDckMsbURBQWlEO0FBQ2pELG1DQUFpQztBQUNqQyw2Q0FBMkM7QUFFM0MsMEJBQWtDLE1BQWM7SUFDOUMsSUFBSSxRQUFRLEdBQUcsZUFBTSxDQUFDLCtCQUFjLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQTtJQUM3QyxJQUFJLGFBQWEsR0FBRyxRQUFRLEdBQUcsQ0FBQyx5QkFBVyxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQSxDQUFBLDZDQUE2QztJQUMzRyxNQUFNLENBQUMsbUJBQVEsQ0FBQyxhQUFhLENBQUMsQ0FBQTtBQUNoQyxDQUFDO0FBSkQsNENBSUMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/BroadcastAddress.ts
// module id = 3
// module chunks = 0